import { ReactNode } from 'react';
import cn from 'classnames';
import Heading from '@components/ui/Heading';
import styles from './ContentPageHeading.module.scss';

interface ContentPageHeadingProps {
  classNames?: string | string[];
  children: ReactNode;
}

const ContentPageHeading = ({
  classNames,
  children,
}: ContentPageHeadingProps) => (
  <Heading
    styleLevel="1"
    semanticLevel="h1"
    className={cn(styles.contentPageHeading, classNames)}
  >
    {children}
  </Heading>
);

export default ContentPageHeading;
